export default {
  SUBJECT_REQUEST: 'SUBJECT_STUDENT/SUBJECT_STUDENT_REQUEST',
  SUBJECT_SUCCESS: 'SUBJECT_STUDENT/SUBJECT_STUDENT_SUCCESS',
  SUBJECT_FAILURE: 'SUBJECT_STUDENT/SUBJECT_STUDENT_FAILURE',
  ACTIVITIES_REQUEST: 'SUBJECT_STUDENT/ACTIVITIES_REQUEST',
  ACTIVITIES_SUCCESS: 'SUBJECT_STUDENT/ACTIVITIES_SUCCESS',
  ACTIVITIES_FAILURE: 'SUBJECT_STUDENT/ACTIVITIES_FAILURE',
}
